export default "__VITE_ASSET__DrXfc04___"